import React, { Component } from 'react';
import {setContextualHelp} from "actions/index.js";
import {TRACK_LOCK_BUTTON} from 'constants/contextual-help.js';
import { connect } from "react-redux";

class LockButton extends Component {
    setContextualHelp(e, help) {
        e.stopPropagation();
        this.props.setContextualHelp(help);
    }
    render() {
        return (
            <div className="lock-button-container">
              <img
                onMouseOver={(e) => this.setContextualHelp(
                  e, this.props.contextualHelp || TRACK_LOCK_BUTTON)}
                onMouseLeave={() => this.props.setContextualHelp(undefined)}
                onClick={() => this.props.toggleLock()}
                className="lock-button"
                src={this.props.patternLocked ? "/closed-padlock.png" : "/opened-padlock.png"}/>
            </div>
        );
    }
}

const mapDispatchToProps = (dispatch, props) => {
    return {
        setContextualHelp: (element) => dispatch(setContextualHelp(element)),
    };
}
 
export default connect(null, mapDispatchToProps)(LockButton);
